import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const opts = { withCredentials: true };

export const RotaDoMesWeb = ({ routes, onOpenRoute }) => {
  const [data, setData] = useState(null);
  const [mine, setMine] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const [w, m] = await Promise.all([
        axios.get(`${API}/gamification/monthly-winner`, opts),
        axios.get(`${API}/gamification/vote/monthly/me`, opts),
      ]);
      setData(w.data);
      setMine(m.data?.route_id ? m.data : null);
    } catch { /* card é opcional */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  const vote = async (r) => {
    setBusy(true);
    try {
      await axios.post(`${API}/gamification/vote/monthly`, { route_id: r.route_id }, opts);
      toast.success('Voto registado — podes alterar até ao fim do mês');
      setOpen(false);
      await load();
    } catch {
      toast.error('Não foi possível registar o voto');
    } finally {
      setBusy(false);
    }
  };

  if (!data) return null;
  const publicRoutes = (routes || []).filter((r) => !(r.is_private ?? (r.group_ids?.length > 0)));
  const winner = data.winner;

  return (
    <div className="mx-4 mt-4 rounded-lg border border-[#E87A2A]/40 bg-[#E87A2A]/5 p-3" data-testid="rota-do-mes-web">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] font-black tracking-widest text-[#E87A2A]">ROTA DO MÊS</span>
        <span className="text-[10px] text-muted-foreground">{data.total_votes} voto{data.total_votes === 1 ? '' : 's'}</span>
      </div>
      {winner ? (
        <button className="text-left w-full" onClick={() => onOpenRoute(winner.route_id)} data-testid="rota-do-mes-web-winner">
          <span className="block font-bold text-sm">🏆 {winner.route?.name || 'Rota destacada'}</span>
          <span className="block text-xs text-muted-foreground">{winner.votes} voto{winner.votes === 1 ? '' : 's'} · em 1º</span>
        </button>
      ) : (
        <p className="text-xs text-muted-foreground">Ainda ninguém votou este mês.</p>
      )}
      {mine && (
        <p className="text-xs font-bold text-green-500 mt-2 truncate" data-testid="rota-do-mes-web-my-vote">
          ✔ O teu voto: {mine.route_name || 'rota escolhida'}
        </p>
      )}
      <Button size="sm" variant="outline" className="w-full mt-2" onClick={() => setOpen(true)} data-testid="rota-do-mes-web-vote-btn">
        {mine ? '↻ Alterar voto' : '🗳️ Votar'}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="rota-do-mes-web-dialog">
          <DialogHeader>
            <DialogTitle>Vota na melhor rota pública deste mês</DialogTitle>
            <DialogDescription>Só rotas públicas. Podes mudar o voto até ao fim do mês.</DialogDescription>
          </DialogHeader>
          <div className="max-h-[60vh] overflow-y-auto space-y-2">
            {publicRoutes.map((r) => {
              const isMine = mine?.route_id === r.route_id;
              return (
                <button
                  key={r.route_id}
                  disabled={busy}
                  onClick={() => vote(r)}
                  className={`w-full text-left rounded-md border p-3 flex items-center gap-2 ${isMine ? 'border-green-500 bg-green-500/10' : 'border-border hover:bg-muted'}`}
                  data-testid={`rota-do-mes-web-row-${r.route_id}`}
                >
                  <span className="flex-1 text-sm font-semibold truncate">{r.name}</span>
                  {isMine && <span className="text-xs font-bold text-green-500">✔ O teu voto</span>}
                </button>
              );
            })}
            {!publicRoutes.length && <p className="text-sm text-muted-foreground">Sem rotas públicas.</p>}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
